module.exports = __webpack_public_path__ + "static/media/47.034ad000.png";